import useNewProduct from "components/allProducts/useNewProduct";
import { createContext } from "react";
//
//
//
const ProductContext = createContext();

const ProductProvider = ({ children }) => {
  const {
    products,
    hidden,
    setHidden,
    prod,
    category,
    sub_category,
    GetCategoryProduct,
    GetsubCategoryProduct,
    GetListByproductType,
    setShowModalQuickView,
    showModalQuickView,
    isLoading,
  } = useNewProduct();

  return (
    <ProductContext.Provider
      value={{
        products,
        hidden,
        setHidden,
        prod,
        category,
        sub_category,
        GetCategoryProduct,
        GetsubCategoryProduct,
        GetListByproductType,
        setShowModalQuickView,
        showModalQuickView,
        isLoading,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export { ProductContext, ProductProvider };
